<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.agentId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in agentOptions"
                      :key="index"
                      :value="item.id"
                      :label="`(${item.code}) ${item.name || ''}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <input v-model="searchParams.bookingCode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nhân viên đặt phòng</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.createUserId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in createUserOptions"
                      :key="index"
                      :value="item.account.id"
                      :label="`(${item.account.username}) ${item.account.full_name}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo giảm giá đặt phòng</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-select-first-row="false"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Recode: Là mã đặt phòng nếu là khách lẻ, là mã đoàn nếu là khách
              đoàn
            </li>
            <li>Tên phòng: Hiển thị tên hạng phòng và tên phòng</li>
            <li>Tên khách: Hiển thị tên khách chính đặt phòng</li>
            <li>Nguồn: hiển thị nguồn của đặt phòng</li>
            <li>Ngày đến: hiển thị ngày đến của đặt phòng</li>
            <li>Ngày đi: Hiển thị ngày đi của đặt phòng</li>
            <li>
              Giá phòng: Hiển thị theo : giá giai đoạn trong mã giá (nếu có)
              hoặc giá mặc định của phòng* số đêm ở
            </li>
            <li>
              Bảng mã giá: Hiển thị mã giá, mã giai đoạn áp dụng cho giá phòng
              (Theo mã giá(Cấu hình> Dịch vụ chính sách và giá bán) -> giá giai
              đoạn)
            </li>
            <li>
              Giảm giá: hiển thị số phần trăm giảm giá được điền khi đặt phòng
            </li>
            <li>Số tiền giảm giá: bằng giá phòng * % giảm giá</li>
            <li>Giá sau giảm: bằng giá phòng - số tiền giảm giá</li>
            <li>
              Nhân viên đặt phòng: Hiển thị tên nhân viên đặt phòng cho đặt
              phòng
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListDiscountBookingReport,
  getListDiscountBookingReportExcel,
  getCreateUserOptions
} from '@/api/report_service/discountBookingReport'
import { getAgentListForReport } from '@/api/report_service/takeMoneybyInvoice'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'

export default {
  components: {
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      agentOptions: [],
      createUserOptions: [],
      loading: false,
      searchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        agentId: null,
        bookingCode: null,
        createUserId: null
      },
      defaultSearchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        agentId: null,
        bookingCode: null,
        createUserId: null
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      columns: [
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 110,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.roomName'),
          field: 'room_num',
          tooltipField: 'room_num',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 130,
          valueGetter: params => {
            return params.data.last_name + ' ' + params.data.first_name
          },
          tooltipValueGetter: params => {
            return params.data.last_name + ' ' + params.data.first_name
          },
          flex: 1,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_code',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.agentName'),
          field: 'agent_name',
          sortable: false,
          minWidth: 170

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 130,
          maxWidth: 130

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'depart_date',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 130,
          maxWidth: 130
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.roomPrice'),
          field: 'room_price',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          minWidth: 120,
          maxWidth: 120

          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.discountMoney'),
          field: 'discount',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          maxWidth: 130,
          // tooltipValueGetter: params => {
          //   if (params.value !== null && params.value !== undefined) {
          //     return Number(params.value).toLocaleString('en')
          //   }
          //   return null
          // },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          }
        },
        {
          headerName: this.$t('grid.column.discountPrice'),
          field: 'price_after_discount',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 140,
          maxWidth: 170,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          }
        },
        {
          headerName: this.$t('grid.column.staffBooking'),
          field: 'sales_person_nm',
          tooltipField: 'sales_person_nm',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          tooltipField: 'note',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 200
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListSource()
    this.getListHotel()
    this.fnGetAgentOptions()
    this.fnGetCreateUserOptions()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        getListDiscountBookingReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'giam_gia_dat_phong_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async fnGetCreateUserOptions() {
      const data = await getCreateUserOptions()
      this.createUserOptions = data.data || []
    },
    async fnGetAgentOptions() {
      const data = await getAgentListForReport()
      this.agentOptions = [{ id: null, code: 'Tất cả' }, ...data.data] || []
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getListDiscountBookingReport(this.searchParams)
        this.loading = false
        this.rows = data.data
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
